"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const companyRegisterDataState_1 = __importStar(require("./companyRegisterDataState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1({ userId, pendingRef, closeDialog, companyRegisterForm, onCompanyInfoFetchSuccess, onCompanyInfoRegisterSuccess, }) {
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const disablePending = () => {
        pendingRef.current = false;
        if (!unmountRef.current) {
            setIsPending(false);
        }
    };
    const { watch, setError, handleSubmit, formState: { dirtyFields }, } = companyRegisterForm;
    const companyPostCode = watch('company_post_code');
    const { t } = (0, react_i18next_1.useTranslation)();
    const validateCompanyAddress = () => {
        if (!companyPostCode) {
            setError('company_post_code', {
                type: 'required',
                message: t('사업장 소재지를 등록해주세요'),
            });
            return false;
        }
        else
            return true;
    };
    const sellerAgreeChannelId = (0, recoil_1.useRecoilValue)(companyRegisterDataState_1.sellerAgreeChannelIdState);
    const validatePublishAgree = () => {
        if (!sellerAgreeChannelId) {
            (0, functions_1.showToastMessage)({ message: t('판매 페이지 게시 선택 후 등록완료 가능해요') });
        }
        return !!sellerAgreeChannelId;
    };
    const setCompanyRegisterData = (0, recoil_1.useSetRecoilState)(companyRegisterDataState_1.default);
    const onAlreadyCompanyInfoError = () => {
        (0, _1.getCompanyRegisterData)({
            userId,
            setCompanyRegisterData,
            onCompanyInfoFetchSuccess,
        });
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const registerCompanyInfo = handleSubmit((registerData) => __awaiter(this, void 0, void 0, function* () {
        const isCompanyAddressValid = validateCompanyAddress();
        if (isCompanyAddressValid) {
            const isPublishAgree = validatePublishAgree();
            if (isPublishAgree && !pendingRef.current) {
                pendingRef.current = true;
                setIsPending(true);
                const data = { company_channel_id: sellerAgreeChannelId };
                const dataKeyArr = Object.keys(dirtyFields);
                dataKeyArr.forEach(keys => Object.assign(data, { [keys]: registerData[keys] }));
                const { proof_files } = registerData;
                if (!!proof_files) {
                    Object.assign(data, { company_registration_image: proof_files[0].media_id });
                }
                (0, api_1.patchData)(`/api/v1/members/${userId}/company-info`, data)
                    .then(() => {
                    !!onCompanyInfoRegisterSuccess && onCompanyInfoRegisterSuccess(registerData);
                    closeDialog();
                })
                    .catch(error => {
                    var _a, _b, _c, _d;
                    const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                    const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                    if (errorStatus === 400) {
                        (0, _1.handleCompanyRegisterBadRequestError)({ error, confirm, onAlreadyCompanyInfoError });
                    }
                    else if (errorStatus === 403)
                        (0, errors_1.handle403Error)(error);
                    else
                        (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                })
                    .finally(disablePending);
            }
        }
    }), validateCompanyAddress);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "sticky-btn-bg", css: { position: 'sticky', bottom: 0, padding: '60px 16px 32px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                width: '100%',
                height: '56px',
                padding: '0 8px',
                borderRadius: '12px',
                color: 'var(--white)',
                backgroundColor: 'var(--primary-main) !important',
            }, onClick: registerCompanyInfo }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('등록 완료') }))) })) })));
}
exports.default = default_1;
